import React, { useState } from "react";
import NavbarThree from "../../Components/Navbar/navbarThree";
import Footer from "../../Components/Footer";
import FokusDetail from "../../Components/FokusPemberdayaan/detailFokus";

const PageDetailFokus = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <>
      <NavbarThree isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

      <div className="pt-16">
        <FokusDetail />
      </div>

      <Footer />
    </>
  );
};

export default PageDetailFokus;
